import { useEffect } from "react";
import { supabase } from "../supabase";
import { showToast } from "../toast";
import {
  appCallbackFromNativeUrl,
  completeAuthSheet,
  isNativeSignInPending,
} from "./nativeAuth";
import { isNativeShell } from "./nativeShell";

/* AuthListener reacts to SIGNED_IN and LoginPage navigates once `user` appears, so no route is needed here. */
export const useNativeAuthRedirect = (): void => {
  useEffect(() => {
    if (!isNativeShell()) return undefined;
    const listener = import("@capacitor/app").then(({ App }) =>
      App.addListener("appUrlOpen", ({ url }) => {
        const params = appCallbackFromNativeUrl(url);
        if (!params || !isNativeSignInPending()) return;
        void completeAuthSheet();
        const failure = params.get("error_description") ?? params.get("error");
        if (failure) {
          showToast(failure, "danger");
          return;
        }
        const code = params.get("code");
        if (!code) return;
        void supabase.auth.exchangeCodeForSession(code).then(({ error }) => {
          if (error) showToast("Sign in failed. Please try again.", "danger");
        });
      }),
    );
    return (): void => {
      void listener.then((handle) => handle.remove());
    };
  }, []);
};
